<template>
  <svg
    width="8"
    height="9"
    viewBox="0 0 8 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="IconIncomingArrow">
      <path
        id="Vector"
        d="M6.39146 7.57088C6.48262 7.65583 6.60319 7.70207 6.72778 7.69988C6.85237 7.69768 6.97123 7.64721 7.05934 7.5591C7.14745 7.47099 7.19792 7.35212 7.20012 7.22754C7.20232 7.10295 7.15607 6.98237 7.07113 6.89121L2.44167 2.26175H6.09009C6.21763 2.26175 6.33995 2.21109 6.43014 2.1209C6.52033 2.03071 6.57099 1.9084 6.57099 1.78085C6.57099 1.65331 6.52033 1.53099 6.43014 1.44081C6.33995 1.35062 6.21763 1.29995 6.09009 1.29995H1.2811C1.21787 1.2997 1.15523 1.31196 1.09677 1.33604C1.03831 1.36012 0.98519 1.39553 0.940484 1.44024C0.895777 1.48495 0.860364 1.53806 0.836287 1.59652C0.812209 1.65498 0.799944 1.71763 0.800199 1.78085V6.58985C0.800199 6.71739 0.850865 6.83971 0.941051 6.9299C1.03124 7.02008 1.15356 7.07075 1.2811 7.07075C1.40864 7.07075 1.53096 7.02008 1.62115 6.9299C1.71133 6.83971 1.762 6.71739 1.762 6.58985V2.94142L6.39146 7.57088Z"
        fill="#434343"
      />
    </g>
  </svg>
</template>
